import { DeviceEntryProps, Profile, ProfileGender, ProfileType, UserProfileEntryProps } from '@watcherr/resources';
import { t } from '~/i18n';

import { State } from '~/store/types';

class UserProfileEntry {
  rootStore: State;
  id: number;
  uuid: string;
  image?: string;
  firstName: string;
  deviceToken?: string;
  createdOn: Date;
  phoneNumber: string;
  secondaryPhoneNumbers?: string;
  email: string;
  lastName: string;
  fullName: string;
  nursingHomeCoordinates?: any;
  hospitalName?: string;
  secondaryResidencyCoordinates?: boolean;
  inNursingHome?: boolean;
  secondaryResidencyName?: string;
  usualResidencyName?: string;
  inHospital?: boolean;
  profileImage?: string;
  residencyName?: string;
  site?: {
    name: string;
    uuid: string;
  };
  floor?: string;
  gender?: ProfileGender;
  roomNumber?: string;
  ownedDevice?: DeviceEntryProps;
  usualResidencyCoordinates?: any;
  nursingHomeName?: string;
  healthLevel?: string;
  katzLevel?: number;
  livingUnitId?: string;
  birthday?: Date;
  teams?: [];
  hcpGroupId?: string | null;

  profileType: ProfileType;
  nationalNumber: string | null;
  constructor(rootStore: State, profile: UserProfileEntryProps) {
    this.rootStore = rootStore;
    this.setProps(profile);
  }

  update(props) {
    Object.keys(props).forEach((key) => {
      this[key] = props[key];
    });
  }

  archive(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.rootStore.confirmation.show({
        title:
          this.profileType === 'RESIDENT'
            ? t('residentDetail.confirmDelete.title')
            : t('healthcareProviderDetail.confirmDelete.title'),
        message:
          this.profileType === 'RESIDENT'
            ? t('residentDetail.confirmDelete.message')
            : t('healthcareProviderDetail.confirmDelete.message'),
        onConfirm: () => {
          Profile.archiveProfile(this.uuid)
            .then(() => {
              resolve(true);
            })
            .catch(() => {
              reject();
            });
        },
        onCancel: () => {
          reject();
        },
      });
    });
  }

  setProps(profile: UserProfileEntryProps) {
    Object.keys(profile).forEach((key) => {
      this[key] = profile[key];
    });
  }
}

export default UserProfileEntry;
